import { createSlice } from '@reduxjs/toolkit';

import { getAdminEditReview, getAdminReviews, updateAdminReview } from './adminReviews.actions';

const initialState = {
  reviews: [],
  reviewsMeta: {},
  isLoadingReviews: false,

  selectedReview: {},
  isLoadingReview: false,

  errors: {},
};

const adminReviewsSlice = createSlice({
  name: 'adminReviews',
  initialState,
  reducers: {
    setAdminReviewsMeta: (state, action) => {
      state.reviewsMeta = action.payload;
    },
    setSelectedReview: (state, action) => {
      state.selectedReview = action.payload;
    },
    setAdminReviewErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminReviews.pending, (state) => {
      state.isLoadingReviews = true;
    });
    builder.addCase(getAdminReviews.fulfilled, (state, action) => {
      state.reviews = action.payload;
      state.isLoadingReviews = false;
    });
    builder.addCase(getAdminReviews.rejected, (state) => {
      state.isLoadingReviews = false;
    });

    builder.addCase(getAdminEditReview.pending, (state) => {
      state.isLoadingReview = true;
    });
    builder.addCase(getAdminEditReview.fulfilled, (state, action) => {
      state.selectedReview = action.payload;
      state.isLoadingReview = false;
    });
    builder.addCase(getAdminEditReview.rejected, (state) => {
      state.isLoadingReview = false;
    });

    builder.addCase(updateAdminReview.pending, (state) => {
      state.isLoadingReview = true;
    });
    builder.addCase(updateAdminReview.fulfilled, (state) => {
      state.isLoadingReview = false;
    });
    builder.addCase(updateAdminReview.rejected, (state) => {
      state.isLoadingReview = false;
    });
  },
});

export const { setAdminReviewsMeta, setSelectedReview, setAdminReviewErrors } =
  adminReviewsSlice.actions;

export default adminReviewsSlice.reducer;
